import React, { useState } from "react";
import Button from "@mui/material/Button";
import Email from "@mui/icons-material/Email";

import DialogLogs from "@repo/legacy/components/shared/dialogs/DialogLogs";
import type { ProjectTimeEntry } from "@repo/server-api";
import type { NewTimeEntry } from "./types";
import { useAddLogToProjectTimeEntryMutation } from "@repo/server-api"; // Adjust the import path if needed

export const LogsCell = ({
	entry,
	refreshData,
}: {
	entry: ProjectTimeEntry | NewTimeEntry;
	refreshData: (entry: ProjectTimeEntry | NewTimeEntry) => void;
}) => {
	const [openLogs, setOpenLogs] = useState(false);

	if (entry.id.match(/^new*/)) return null;

	const [addLog] = useAddLogToProjectTimeEntryMutation({
		fetchPolicy: "no-cache",
	});

	const handleAddLog = async (message: string) => {
		addLog({
			variables: {
				timeEntryId: entry.id,
				message: message || "",
			},
		}).then((res: any) => {
			const updatedEntry = res.data?.addLogToProjectTimeEntry?.projectTimeEntry;
			if (updatedEntry) {
				refreshData(updatedEntry);
			}
		});
	};

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}>
			<Button
				variant="contained"
				className="blueButton"
				color="secondary"
				onClick={() => {
					setOpenLogs(!openLogs);
				}}
				style={{
					width: "50px",
					height: "25px",
					margin: "5px auto",
				}}>
				{entry.logs.length} <Email sx={{ ml: 2.5 }} />
			</Button>
			<DialogLogs open={openLogs} setOpen={setOpenLogs} logs={entry.logs} addLog={handleAddLog} />
		</div>
	);
};
